//images
import SiteIcon from '../images/internet.svg';
import AddressIcon from '../images/point.svg';
import WorkTimeIcon from '../images/clock.svg';
import PhoneIcon from '../images/phone.svg';
import EmailIcon from '../images/email.svg';

//types
import { IStoreItemProps } from '../types/IStoreItemProps';

export default function StoreItem({
    store,
}: IStoreItemProps){
    const rusLangData = store?.langs?.ru ?? null;

    const site = store?.url ?? null;
    const name = rusLangData?.name ?? null;
    const address = rusLangData?.address ?? null;
    const workHours = rusLangData?.workHours ?? null;
    const phone = rusLangData?.phone ?? null;
    const email = rusLangData?.email ?? null;

    return (
        <div className="stores-list__item store-item" key={store.id}>
            <div className="store-item__inner">
                <div className="store-item__name">{name}</div>
                {address ? (
                    <div className="store-item__address"> 
                        <img 
                            src={AddressIcon}
                            alt="icon"
                        />
                        {address}
                    </div>
                ) : null}
                {workHours ? (
                    <div className="store-item__worktime"> 
                        <img 
                            src={WorkTimeIcon}
                            alt="icon"
                        />
                        {workHours}
                    </div>
                ) : null}
                {phone ? (
                    <div className="store-item__phone"> 
                        <img 
                            src={PhoneIcon}
                            alt="icon"
                        />
                        {phone}
                    </div>
                ) : null}
                {site ? (
                    <div className="store-item__site"> 
                        <img 
                            src={SiteIcon}
                            alt="icon"
                        />
                        {site}
                    </div>
                ) : null}
                {email ? (
                    <div className="store-item__email"> 
                        <img 
                            src={EmailIcon}
                            alt="icon"
                        />
                        {email}
                    </div>
                ) : null}
            </div>
        </div>
    );
}